<template>
	<div class="vaillant">
		<AuthorizedService logo="vaillant-big.png" />
		<Services />		
		<Recipients />	
		<ContactForm />		
	</div>
</template>

<script>
import AuthorizedService from '@/components/AuthorizedService.vue';
import Services from '@/components/Services.vue';
import Recipients from '@/components/Recipients.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
	name: 'Vaillant',
	components: {
		AuthorizedService,
		Services,
		Recipients,
		ContactForm
	},
	metaInfo: {
		title: 'Serwis Vaillant Warszawa - Instalacje centralnego ogrzewania',
		// override the parent template and just use the above title only
		titleTemplate: null,
		meta: [
			{ charset: 'utf-8' },
			{ name: 'description', content: 'Świadczymy kompleksową opiekę serwisową pieców Vaillant: naprawy gwarancyjne i pogwarancyjne, przeglądy okresowe, regulacja i konserwacja urządzeń instalacji centralnego ogrzewania.' }
		]
	}
}
</script>